// Country data sourced from the `country-list` package (single source of truth,
// shared shape with server/utils/countries.js). Stored value is the ISO
// alpha-2 `code`; the `name` is shown to the user.
import { getData, getName } from 'country-list';

// Alphabetical by name, with South Africa pinned to the top (primary market).
const sorted = getData()
  .slice()
  .sort((a, b) => a.name.localeCompare(b.name));
export const countries = [
  ...sorted.filter((c) => c.code === 'ZA'),
  ...sorted.filter((c) => c.code !== 'ZA')
];

// Options shaped for IndentedDropdown ({ key: label, value }).
export const countryOptions = countries.map((c) => ({
  key: c.name,
  value: c.code
}));

// Look up the full country name for an ISO code (falls back to the code).
export const countryNameFromCode = (code) => {
  if (!code) return '';
  return getName(code) || code;
};
